import React from "react";
import {
  ActionButton,
  BalanceText,
  Container,
  Text,
  TopUpAndWithDrawContainer,
  WalletContainer,
  WalletTitle,
  WalletDataContainer,
} from "./WalletCard.style";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import {
  BalanceLoading,
  WalletCardArrowIcon,
  WalletIcon,
  PlusIconForTopUp,
  WithdrawIcon,
} from "@assets";
import { useNavigate } from "react-router-dom";
import { PRIVATE_ROUTE } from "@router/route.constants";
import { useDispatch, useSelector } from "react-redux";
import { setOpenLoginAlert } from "@redux/auth/authSlice";
import { TOPUP_LK } from "@constants";
import Lottie from "react-lottie";

const WalletCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const { main_balance, bonus, is_in_game } = useSelector(
    (state) => state.auth.user
  );

  const goToWallet = () => {
    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WALLET}`);
  };

  const goToTopUp = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const goToWithdraw = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const checkIsLoggedIn = () => {
    if (!isLoggedIn) {
      dispatch(setOpenLoginAlert(true));
    }
    return isLoggedIn;
  };

  return (
    <Container>
      <WalletContainer onClick={goToWallet}>
        <WalletIcon />
        <WalletDataContainer>
          <WalletTitle> {t("wallet.walletTitle")} </WalletTitle>
          <BalanceText>
            {is_in_game ? (
              <Lottie
                options={{
                  animationData: BalanceLoading,
                }}
                width={32}
                height={32}
              />
            ) : (
              `${getFormattedNumber(main_balance + bonus)} Ks`
            )}
          </BalanceText>
        </WalletDataContainer>
        <WalletCardArrowIcon />
      </WalletContainer>

      <TopUpAndWithDrawContainer>
        <ActionButton onClick={goToTopUp}>
          <Text>{t("wallet.walletTopUp")}</Text>
          <PlusIconForTopUp />
        </ActionButton>

        <ActionButton onClick={goToWithdraw}>
          <Text>{t("wallet.walletWithdraw")}</Text>
          <WithdrawIcon />
        </ActionButton>
      </TopUpAndWithDrawContainer>

    </Container>
  );
};

export default WalletCard;
